/* Deur-variantstappen (solza-door-options.liquid), bovenop de vendor
   variant-picker.js die de echte selectie/prijs/URL afhandelt.

   Regels hier:
   1. Alleen combinaties die als variant bestaan zijn kiesbaar; de rest
      wordt uitgeschakeld weergegeven. Wordt de huidige keuze ongeldig
      door een wissel eerder in de rij, dan springt de stap naar de
      eerste nog geldige waarde.
   2. De stap Draairichting verdwijnt wanneer de gekozen maat+type
      alleen "Niet van toepassing" kent; de waarde wordt dan stil op
      "Niet van toepassing" gezet. De pil "Niet van toepassing" is
      nooit een zichtbare keuze.
   3. Stapnummers zijn CSS-counters; verbergen van een stap hernummert
      dus vanzelf. */
(function () {
  function initAll() {
    document.querySelectorAll('[data-door-options]:not([data-door-init])').forEach(init);
  }

  function init(root) {
    root.setAttribute('data-door-init', '');
    var naValue = root.getAttribute('data-door-na-value') || 'Niet van toepassing';
    var dataEl = root.querySelector('[data-door-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var steps = [].slice.call(root.querySelectorAll('[data-door-step]'));
    if (!steps.length) return;

    function optionIndex(step) {
      var node = step.querySelector('.m-product-option--node');
      return node ? parseInt(node.getAttribute('data-option-position'), 10) - 1 : -1;
    }

    function selectedValues() {
      return steps.map(function (step) {
        var checked = step.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    /* bestaat er een variant waarvan de opties tot en met index
       `depth` overeenkomen met `values`? */
    function combinationExists(values, depth) {
      return variants.some(function (v) {
        for (var i = 0; i <= depth; i++) {
          if (values[i] == null) continue;
          if (v.options[optionIndex(steps[i])] !== values[i]) return false;
        }
        return true;
      });
    }

    function refresh() {
      var values = selectedValues();

      steps.forEach(function (step, stepIdx) {
        var stepValues = values.slice();
        step.querySelectorAll('.m-product-option--node').forEach(function (node) {
          stepValues[stepIdx] = node.getAttribute('data-value');
          var exists = combinationExists(stepValues, stepIdx);
          node.classList.toggle('solza-door-pill--unavailable', !exists);
          var input = node.querySelector('input[type="radio"]');
          if (input) input.toggleAttribute('data-door-unavailable', !exists);
        });

        /* keuze ongeldig geworden -> eerste geldige waarde kiezen */
        var checked = step.querySelector('input[type="radio"]:checked');
        if (checked && checked.hasAttribute('data-door-unavailable')) {
          var firstValid = step.querySelector('.m-product-option--node:not(.solza-door-pill--unavailable) input[type="radio"]');
          if (firstValid) { firstValid.click(); return; }
        }
      });

      /* draairichting-stap tonen of verbergen. Twee regels:
         1. Bij Type = Stomp (data-door-universal-type) verdwijnt de
            stap ALTIJD: een stompe deur heeft geen scharnier-
            voorbereiding en is universeel. Onderliggend wordt stil
            de eerste bestaande stompe variant gekozen -- de data
            draagt daar per serie 'Niet van toepassing' of een
            richtingswaarde, dat maakt voor de klant niet uit.
         2. Anders: verbergen wanneer alleen "Niet van toepassing"
            bestaat (regel uit de werkelijke variantcombinaties). */
      var universalType = root.getAttribute('data-door-universal-type') || '';
      var chosenType = (function () {
        var typeStep = steps.filter(function (s) { return s.getAttribute('data-option-name') === 'Type'; })[0];
        var c = typeStep && typeStep.querySelector('input[type="radio"]:checked');
        return c ? c.value : null;
      })();

      steps.forEach(function (step, stepIdx) {
        if (step.getAttribute('data-option-name') !== 'Draairichting') return;
        var naNode = step.querySelector('.m-product-option--node[data-value="' + cssEscape(naValue) + '"]');
        if (naNode) naNode.classList.add('solza-door-pill--na');

        var allNodes = [].slice.call(step.querySelectorAll('.m-product-option--node'));
        var others = allNodes.filter(function (n) { return n !== naNode; });
        var anyOtherAvailable = others.some(function (n) { return !n.classList.contains('solza-door-pill--unavailable'); });

        var typeIsUniversal = universalType && chosenType === universalType;

        if (typeIsUniversal || !anyOtherAvailable) {
          step.classList.add('solza-door-step--hidden');
          /* stil de eerste BESTAANDE combinatie kiezen (NvT of een
             richtingswaarde, wat de data ook draagt) */
          var checked = step.querySelector('input[type="radio"]:checked');
          if (!checked || checked.hasAttribute('data-door-unavailable')) {
            var firstValid = allNodes.filter(function (n) { return !n.classList.contains('solza-door-pill--unavailable'); })[0];
            if (firstValid) firstValid.querySelector('input[type="radio"]').click();
          }
        } else {
          step.classList.remove('solza-door-step--hidden');
          /* staat de keuze nog op NvT terwijl er echte richtingen
             zijn, kies dan de eerste beschikbare richting */
          var checkedDir = step.querySelector('input[type="radio"]:checked');
          if (checkedDir && checkedDir.value === naValue) {
            var firstDir = others.filter(function (n) { return !n.classList.contains('solza-door-pill--unavailable'); })[0];
            if (firstDir) firstDir.querySelector('input[type="radio"]').click();
          }
        }
      });
    }

    function cssEscape(v) {
      return (window.CSS && CSS.escape) ? CSS.escape(v) : v.replace(/"/g, '\\"');
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) {
        /* na de vendor-afhandeling opnieuw evalueren */
        requestAnimationFrame(refresh);
        setTimeout(refresh, 50);
      }
    });

    /* klikken op een uitgeschakelde pil blokkeren */
    root.addEventListener('click', function (e) {
      var node = e.target.closest('.solza-door-pill--unavailable');
      if (node) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    refresh();
    initExtras(root, variants);
    initAccFilter(root);
  }

  /* -- maatfilter op de toebehoren-rij ------------------------------
     Server-side krijgt elke kaart data-acc-width (0 = maatloos, blijft
     altijd staan). Bij een maatwissel herfiltert dit dezelfde regel
     als de server: tonen bij breedte-match of maatloos, tot het
     maximum (data-acc-max) aan zichtbare kaarten; nul zichtbaar =
     hele blok verborgen. */
  function initAccFilter(root) {
    var block = document.querySelector('.solza-door-acc-block');
    if (!block) return;
    var max = parseInt(block.getAttribute('data-acc-max'), 10) || 6;

    function selectedSize() {
      var maatStep = root.querySelector('[data-door-step][data-option-name="Maat"]');
      var checked = maatStep && maatStep.querySelector('input[type="radio"]:checked');
      if (!checked) return { w: null, h: null };
      var parts = checked.value.split('x');
      var w = parseFloat((parts[0] || '').replace(',', '.'));
      var h = parseFloat((parts[1] || '').replace('cm', '').trim().replace(',', '.'));
      return { w: isNaN(w) ? null : w, h: isNaN(h) ? null : h };
    }

    function apply() {
      var sel = selectedSize();
      var shown = 0;
      [].slice.call(block.querySelectorAll('.solza-door-acc')).forEach(function (row) {
        var rw = parseFloat(row.getAttribute('data-acc-width') || '0') || 0;
        var widthOk = rw === 0 || sel.w === null || Math.abs(rw - sel.w) < 0.01;
        /* hoogteclaim: "201.5/211.5" past bij beide hoogtes */
        var rh = row.getAttribute('data-acc-heights') || '';
        var heightOk = rh === '' || sel.h === null || rh.split('/').some(function (v) {
          return Math.abs(parseFloat(v) - sel.h) < 0.01;
        });
        var visible = widthOk && heightOk && shown < max;
        if (visible) shown++;
        row.hidden = !visible;
      });
      block.hidden = shown === 0;
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-door-step] input[type="radio"]')) {
        /* na de stille doorschakel-kliks van refresh() opnieuw meten */
        setTimeout(apply, 60);
      }
    });
  }

  /* -- stappen 4-6 (Afwerking/Glas/Bewerkingen) --------------------
     Extra keuzes bovenop de variant. Toeslagen (uit de server-side
     gerenderde data-attributen) tellen op bij de variantprijs in de
     totaalregel en de sticky balk; gekozen opties gaan als line item
     properties mee met de winkelwagenregel. De retourmelding
     verschijnt zodra er wordt afgelakt of bewerkt. */
  function initExtras(root, variants) {
    var extraSteps = [].slice.call(root.querySelectorAll('[data-door-extra]'));
    var returnNote = root.querySelector('[data-door-return-note]');
    if (!extraSteps.length) return;

    var productId = root.getAttribute('data-product-id');
    var mainForm = document.querySelector('.m-product-form--main form');
    var priceEl = document.querySelector('.main-product__block-price .m-price-item');
    var stickyPriceEl = document.querySelector('[data-sticky-atc-price]');
    var basePrice = null;

    /* startprijs: de nu geselecteerde variant (of de eerste) */
    var idInput = mainForm && mainForm.querySelector('[name="id"]');
    var startId = idInput && Number(idInput.value);
    var startVariant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === startId) { startVariant = variants[i]; break; }
    }
    basePrice = (startVariant || variants[0] || {}).price;

    function surchargeInputs() {
      return [].slice.call(root.querySelectorAll('[data-door-extra] input[data-door-surcharge]'));
    }

    function state() {
      var total = 0;
      var lakt = false, bewt = false;
      var props = [];
      surchargeInputs().forEach(function (input) {
        if (!input.checked) return;
        var cents = parseInt(input.getAttribute('data-door-surcharge'), 10) || 0;
        total += cents;
        var step = input.closest('[data-door-extra]');
        var kind = step && step.getAttribute('data-door-extra');
        var prop = input.getAttribute('data-door-prop') || '';
        if (kind === 'finish' && prop) { lakt = true; props.push(['Afwerking', prop]); }
        if (kind === 'glass' && prop) { props.push(['Glas', prop]); }
        if (kind === 'processing' && prop) {
          bewt = true;
          props.push(['Bewerking: ' + prop, input.getAttribute('data-door-prop-value') || 'Ja']);
        }
      });
      return { surcharge: total, lakt: lakt, bewt: bewt, props: props };
    }

    function syncProps(props) {
      if (!mainForm) return;
      [].slice.call(mainForm.querySelectorAll('[data-door-extra-prop]')).forEach(function (el) { el.remove(); });
      props.forEach(function (pair) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + pair[0] + ']';
        input.value = pair[1];
        input.setAttribute('data-door-extra-prop', '');
        mainForm.appendChild(input);
      });
    }

    function render() {
      var s = state();
      if (typeof formatMoney === 'function' && window.MinimogSettings && basePrice != null) {
        var totalText = formatMoney(basePrice + s.surcharge, MinimogSettings.money_format);
        if (priceEl) priceEl.textContent = totalText;
        if (stickyPriceEl) stickyPriceEl.textContent = totalText;
      }
      if (returnNote) returnNote.hidden = !(s.lakt || s.bewt);
      syncProps(s.props);
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-door-extra]')) render();
    });

    /* variantwissel: nieuwe basisprijs, daarna toeslagen er weer
       bovenop (na de vendor- en sticky-updates in dezelfde tick) */
    if (window.MinimogEvents && productId) {
      window.MinimogEvents.subscribe(productId + '__VARIANT_CHANGE', function (variant) {
        if (variant && variant.price != null) basePrice = variant.price;
        setTimeout(render, 0);
      });
    }

    /* glas-ondertitel volgt de gekozen breedte ("past bij 78 cm") */
    var widthEl = root.querySelector('[data-door-glass-width]');
    if (widthEl) {
      var template = widthEl.getAttribute('data-door-glass-width-template') || '';
      root.addEventListener('change', function (e) {
        if (!e.target.matches('input[type="radio"]')) return;
        var maatStep = root.querySelector('[data-door-step][data-option-name="Maat"]');
        var checked = maatStep && maatStep.querySelector('input[type="radio"]:checked');
        if (checked && template) {
          var breedte = (checked.value.split('x')[0] || '').trim();
          widthEl.textContent = template.replace('%b%', breedte);
        }
      });
    }

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
